module.exports = __webpack_public_path__ + "static/pattern-key-grid-terminology-77567b162e369778a62f5ab844e38134.png";